import { render } from "./Live.vue?vue&type=template&id=3b101c2a&scoped=true"
import script from "./Live.vue?vue&type=script&lang=js"
export * from "./Live.vue?vue&type=script&lang=js"

import "./Live.vue?vue&type=style&index=0&id=3b101c2a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b101c2a"],['__file',"src/apps/quiz/routes/Live.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3b101c2a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3b101c2a', __exports__)) {
    api.reload('3b101c2a', __exports__)
  }
  
  module.hot.accept("./Live.vue?vue&type=template&id=3b101c2a&scoped=true", () => {
    api.rerender('3b101c2a', render)
  })

}


export default __exports__